export enum TenantType {
  previous = "previous",
  incoming = "incoming",
  current = "current",
  outgoing = "outgoing",
}

export const tenantIcon = (type: TenantType) => {
  switch (type) {
    case TenantType.incoming:
      return "bi-arrow-down-circle-fill text-success";
    case TenantType.outgoing:
      return "bi bi-arrow-up-circle-fill text-danger";
    case TenantType.current:
      return;
    case TenantType.previous:
      return;
  }
};

export const tenantTitle = (type: TenantType) => {
  switch (type) {
    case TenantType.incoming:
      return "Entrant";
    case TenantType.outgoing:
      return "Sortant";
    case TenantType.current:
      return "Courant";
    case TenantType.previous:
      return "Précédent";
    default:
      return "Aucun";
  }
};
